// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { QueryCache, QueryClient, QueryKey } from '@tanstack/react-query';

export const DEFAULT_POLL_INTERVAL = 2500;

const queryLabel = (queryKey: QueryKey): string => {
  const [head] = queryKey;
  if (typeof head === 'string') {
    return head;
  }
  if (head && typeof head === 'object' && 'templateId' in head) {
    return String((head as { templateId: unknown }).templateId);
  }
  return 'unknown';
};

export const queryClient = (pollingEnabled?: boolean) =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        console.error(`Query failed: ${queryLabel(query.queryKey)}`, error);
      },
    }),
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: pollingEnabled,
        refetchInterval: pollingEnabled ? DEFAULT_POLL_INTERVAL : false,
        keepPreviousData: true,
      },
      mutations: {
        retry: 1,
      },
    },
  });
